import React from 'react'
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import SvgIcon from '@mui/material/SvgIcon';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import Link from '@mui/material/Link';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

const drawerWidth = 240;
  
const Nav1 = [
{ name: 'Home', href: '/', icon: <SvgIcon><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>home-circle-outline</title><path d="M12 20C7.6 20 4 16.4 4 12S7.6 4 12 4 20 7.6 20 12 16.4 20 12 20M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M11 14H13V17H16V12H18L12 7L6 12H8V17H11V14" /></svg></SvgIcon> },
{ name: 'Barcode Gen', href: '/bargen', icon: <SvgIcon><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>barcode</title><path d="M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z" /></svg> </SvgIcon> },
{ name: 'Barcode Reader', href: '/barreader', icon: <SvgIcon><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>barcode-scan</title><path d="M4,6H6V18H4V6M7,6H8V18H7V6M9,6H12V18H9V6M13,6H14V18H13V6M16,6H18V18H16V6M19,6H20V18H19V6M2,4V8H0V4A2,2 0 0,1 2,2H6V4H2M22,2A2,2 0 0,1 24,4V8H22V4H18V2H22M2,16V20H6V22H2A2,2 0 0,1 0,20V16H2M22,20V16H24V20A2,2 0 0,1 22,22H18V20H22Z" /></svg></SvgIcon> },
{ name: 'QRcode Gen', href: '/qrgen', icon: <QrCode2Icon /> },
{ name: 'QRode Reader', href: '/htmlreader', icon: <QrCodeScannerIcon /> },
]

const Nav2 = [
{ name: 'Text To Speech', href: '/text2speech', icon: <RecordVoiceOverIcon /> },
{ name: 'Image Resize', href: '/imgresize', icon: <AspectRatioIcon /> },
]

const AppBar = styled(MuiAppBar, {
        shouldForwardProp: (prop) => prop !== 'open',
})
(({ theme }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
    {
        props: ({ open }) => open,
        style: {
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: drawerWidth,
        },
    },
    ],
}));
    
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));

const Navbar = () => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
  
    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setOpen(false);
    };

  return (
    <div className="flex p-2 w-full text-white bg-cyan-700">
        <Box sx={{ display: 'flex' }} >
            <CssBaseline />
            <AppBar position="fixed" open={open}>
                <Toolbar>
                    <div className="shrink-0">
                        <Link href="/">    
                            <img
                                alt="freelance.in.th"
                                src="/freelanceinth1.png"
                                className="App-logo"
                            />
                        </Link>
                    </div>                
                    <Typography variant="h6" noWrap sx={{ flexGrow: 1, marginLeft: 2 }} component="div">
                            FreelanceinTH Tools
                    </Typography>
                    
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerOpen}
                        sx={[open && { display: 'none' }]}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                },
                }}
                variant="persistent"
                anchor="right"
                open={open}
            >
            <DrawerHeader>
                <IconButton onClick={handleDrawerClose}>
                    {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                </IconButton>
            </DrawerHeader>
            <Divider />
                <List>
                {Nav1.map((nav, index) => (
                    <ListItem key={nav.name} disablePadding>
                    <Link href={nav.href}>
                        <ListItemButton>
                            <ListItemIcon>
                                {nav.icon}
                                
                            </ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                    </Link>
                    </ListItem>
                ))}
                </List>
                <Divider />
                <List>
                {Nav2.map((nav, index) => (
                    <ListItem key={nav.name} disablePadding>
                        <Link href={nav.href}>
                        <ListItemButton>
                            <ListItemIcon>
                                {nav.icon}
                                
                            </ListItemIcon>
                            <ListItemText primary={nav.name} />
                        </ListItemButton>
                        </Link>
                    </ListItem>
                ))}
                </List>
            </Drawer>
        </Box>
                    
    </div>
  )
}

export default Navbar